import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function Account() {
	const { user, changePassword, changeEmail, changeUsername, deleteAccount } = useAuth()
	const navigate = useNavigate()

	const [unameNew, setUnameNew]       = useState('')
	const [unameError, setUnameError]   = useState('')
	const [unameSuccess, setUnameSuccess] = useState('')
	const [unameLoading, setUnameLoading] = useState(false)

	const [pwdCurrent, setPwdCurrent] = useState('')
	const [pwdNew, setPwdNew]         = useState('')
	const [pwdConfirm, setPwdConfirm] = useState('')
	const [pwdError, setPwdError]     = useState('')
	const [pwdSuccess, setPwdSuccess] = useState('')
	const [pwdLoading, setPwdLoading] = useState(false)

	const [emailNew, setEmailNew]       = useState('')
	const [emailPwd, setEmailPwd]       = useState('')
	const [emailError, setEmailError]   = useState('')
	const [emailSuccess, setEmailSuccess] = useState('')
	const [emailLoading, setEmailLoading] = useState(false)

	const [delPwd, setDelPwd]     = useState('')
	const [delError, setDelError] = useState('')
	const [delLoading, setDelLoading] = useState(false)

	async function handleChangeUsername(e) {
		e.preventDefault()
		setUnameError(''); setUnameSuccess('')
		setUnameLoading(true)
		try {
			const msg = await changeUsername(unameNew)
			setUnameSuccess(msg)
			setUnameNew('')
		} catch (err) {
			setUnameError(err.message)
		} finally {
			setUnameLoading(false)
		}
	}

	async function handleChangePassword(e) {
		e.preventDefault()
		setPwdError(''); setPwdSuccess('')
		if (pwdNew !== pwdConfirm) { setPwdError('Passwords do not match'); return }
		setPwdLoading(true)
		try {
			const msg = await changePassword(pwdCurrent, pwdNew)
			setPwdSuccess(msg)
			setPwdCurrent(''); setPwdNew(''); setPwdConfirm('')
		} catch (err) {
			setPwdError(err.message)
		} finally {
			setPwdLoading(false)
		}
	}

	async function handleChangeEmail(e) {
		e.preventDefault()
		setEmailError(''); setEmailSuccess('')
		setEmailLoading(true)
		try {
			const msg = await changeEmail(emailNew, emailPwd)
			setEmailSuccess(msg)
		} catch (err) {
			setEmailError(err.message)
		} finally {
			setEmailLoading(false)
		}
	}

	async function handleDeleteAccount(e) {
		e.preventDefault()
		if (!window.confirm('Are you sure? This action is irreversible.')) return
		setDelError('')
		setDelLoading(true)
		try {
			await deleteAccount(delPwd)
			navigate('/')
		} catch (err) {
			setDelError(err.message)
			setDelLoading(false)
		}
	}

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>My account</h2>
				<p style={{ color: '#6c757d', marginBottom: '0.25rem' }}>{user?.username}</p>
				<p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1.5rem' }}>{user?.email}</p>

				{/* ── Change username ── */}
				<h3 style={{ fontSize: '1rem', marginBottom: '1rem' }}>Change username</h3>
				{unameError   && <div className='authError'>{unameError}</div>}
				{unameSuccess && <div className='authSuccess'>{unameSuccess}</div>}
				{!unameSuccess && (
					<form onSubmit={handleChangeUsername}>
						<div className='authField'>
							<label>New username <small>(3-30 characters, letters, numbers, _ or -)</small></label>
							<input
								type='text'
								value={unameNew}
								onChange={e => setUnameNew(e.target.value)}
								required
								minLength={3}
								maxLength={30}
								pattern='[a-zA-Z0-9_\-]+'
								title='Letters, numbers, underscores and hyphens only'
								placeholder={user?.username}
							/>
						</div>
						<button className='authBtn' disabled={unameLoading}>
							{unameLoading ? 'Saving…' : 'Update username'}
						</button>
					</form>
				)}

				{/* ── Change password ── */}
				<hr style={{ margin: '2rem 0 1.5rem' }} />
				<h3 style={{ fontSize: '1rem', marginBottom: '1rem' }}>Change password</h3>
				{pwdError   && <div className='authError'>{pwdError}</div>}
				{pwdSuccess && <div className='authSuccess'>{pwdSuccess}</div>}
				<form onSubmit={handleChangePassword}>
					<div className='authField'>
						<label>Current password</label>
						<input type='password' value={pwdCurrent} onChange={e => setPwdCurrent(e.target.value)} required />
					</div>
					<div className='authField'>
						<label>New password <small>(8 characters minimum)</small></label>
						<input type='password' value={pwdNew} onChange={e => setPwdNew(e.target.value)} required minLength={8} />
					</div>
					<div className='authField'>
						<label>Confirm new password</label>
						<input type='password' value={pwdConfirm} onChange={e => setPwdConfirm(e.target.value)} required />
					</div>
					<button className='authBtn' disabled={pwdLoading}>
						{pwdLoading ? 'Saving…' : 'Update password'}
					</button>
				</form>

				{/* ── Change email ── */}
				<hr style={{ margin: '2rem 0 1.5rem' }} />
				<h3 style={{ fontSize: '1rem', marginBottom: '1rem' }}>Change email</h3>
				{emailError   && <div className='authError'>{emailError}</div>}
				{emailSuccess && <div className='authSuccess'>{emailSuccess}</div>}
				{!emailSuccess && (
					<form onSubmit={handleChangeEmail}>
						<div className='authField'>
							<label>New email address</label>
							<input type='email' value={emailNew} onChange={e => setEmailNew(e.target.value)} required />
						</div>
						<div className='authField'>
							<label>Current password (confirmation)</label>
							<input type='password' value={emailPwd} onChange={e => setEmailPwd(e.target.value)} required />
						</div>
						<button className='authBtn' disabled={emailLoading}>
							{emailLoading ? 'Saving…' : 'Update email'}
						</button>
					</form>
				)}

				{/* ── Delete account ── */}
				<div className='authDanger'>
					<h3>Delete account</h3>
					{delError && <div className='authError'>{delError}</div>}
					<form onSubmit={handleDeleteAccount}>
						<div className='authField'>
							<label>Confirm with your password</label>
							<input type='password' value={delPwd} onChange={e => setDelPwd(e.target.value)} required />
						</div>
						<button className='authBtn' disabled={delLoading}>
							{delLoading ? 'Deleting…' : 'Delete my account'}
						</button>
					</form>
				</div>
			</div>
		</div>
	)
}

export default Account
